import { SectionCard } from '@/components/ui/SectionCard';
import { useI18n } from '@/hooks/useI18n';
import { TeamGrid } from './components/TeamGrid';
import { teamMembers } from './data';

const PeoplePage = () => {
  const { t } = useI18n();

  return (
    <section className="dashboard">
      <div className="dashboard-inner">
        <header className="dashboard-head">
          <div>
            <p className="breadcrumbs">{t('drawer.group.education')}</p>
            <h2>{t('dashboard.peopleTitle')}</h2>
          </div>
        </header>

        <div className="full-grid">
          <SectionCard
            title={t('dashboard.team')}
            hint={t('dashboard.teamCount', { count: teamMembers.length })}
            span={12}
          >
            <TeamGrid />
          </SectionCard>
        </div>
      </div>
    </section>
  );
};

export default PeoplePage;
